// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 PUT /api/visit8 */
export async function visit8ControllerUpdate(
	body: API.Visit8UpdateRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/visit8', {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/visit8/${param0} */
export async function visit8ControllerGet(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.Visit8ControllerGetParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<API.Visit8ViewResponse>(`/api/visit8/${param0}`, {
		method: 'GET',
		params: { ...queryParams },
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/visit8/${param0} */
export async function visit8ControllerCreate(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.Visit8ControllerCreateParams,
	body: API.Visit8CreateRequest,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<boolean>(`/api/visit8/${param0}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		params: { ...queryParams },
		data: body,
		...(options || {}),
	});
}
